import { isEqual } from 'lodash';
import { distinctUntilChanged, map, of, shareReplay } from "rxjs";
import { Injectable } from '@angular/core';
import { Actions, ofActionCompleted, Store } from '@ngxs/store';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatStates from '@medsurf/flat-states';

@Injectable()
export class SearchControlFacade {

  constructor(protected store: Store,
              protected actions$: Actions) {
  }

  //<editor-fold desc="Selectors">

  nodeSearchResult$ = this.store.select(FlatStates.SearchControlState.nodeSearchResult$).pipe(distinctUntilChanged((previous, current) => isEqual(previous, current)), shareReplay());
  mediaSearchResult$ = this.store.select(FlatStates.SearchControlState.mediaSearchResult$).pipe(distinctUntilChanged((previous, current) => isEqual(previous, current)), shareReplay());
  detachedPageSearchResult$ = this.store.select(FlatStates.SearchControlState.detachedPageSearchResult$).pipe(distinctUntilChanged((previous, current) => isEqual(previous, current)), shareReplay());
  detachedPagesSet$ = this.store.select(FlatStates.SearchControlState.detachedPagesSet$);
  currentSelectedMedia$ = this.store.select(FlatStates.SearchControlState.currentSelectedMedia$);
  currentSelectedNode$ = this.store.select(FlatStates.SearchControlState.currentSelectedNode$);

  //</editor-fold>

  //<editor-fold desc="Lazy Selectors">

  page$ = (id: any) => this.store.select(FlatStates.PageEntityState.entity$).pipe(map(filterFn => filterFn(id as unknown as string)));
  media$ = (id: any) => this.store.select(FlatStates.MediaEntityState.entity$).pipe(map(filterFn => filterFn(id as unknown as string)));
  user$ = (id: any) => this.store.select(FlatStates.UserEntityState.entity$).pipe(map(filterFn => filterFn(id as unknown as string)));

  //</editor-fold>


  //<editor-fold desc="Snapshot Selectors">
  
  snapshot_currentSelectedMedia = () => this.store.selectSnapshot(FlatStates.SearchControlState.currentSelectedMedia$);

  snapshot_nodeSearchResult = () => this.store.selectSnapshot(FlatStates.SearchControlState.nodeSearchResult$);

  //</editor-fold>

  //<editor-fold desc="Actions">

  ofActionDispatchedSearchSuccess = this.actions$.pipe(ofActionCompleted(FlatActions.SearchControlActions.FindSuccess));

  //</editor-fold>

  //<editor-fold desc="Requests">

  requestFindNodes(search: FlatModels.SearchControlModels.NodeSearch) {
    return this.store.dispatch(new FlatActions.SearchControlActions.FindNodes(search));
  }

  requestFindMedia(search: FlatModels.SearchControlModels.MediaSearch) {
    if (!search) {
      search = { first: 0, sortOrder: 1, rows: 1 }
    }
    return this.store.dispatch(new FlatActions.SearchControlActions.FindMedia(search));
  }

  requestFindDetachedPages(search: FlatModels.SearchControlModels.NodeSearch) {
    return this.store.dispatch(new FlatActions.SearchControlActions.FindDetachedPages(search));
  }
  
  requestSetCurrentSelectedMediaResultByMedia(media: FlatModels.MediaEntityModels.MediaEntityType) {
    const mediaSearchResults = this.store.selectSnapshot(FlatStates.SearchControlState.mediaResult$);
    const mediaResult = mediaSearchResults.items[media.id];
    if (mediaResult) {
      return this.requestSetCurrentSelectedMediaResult(mediaResult);
    }
    return of({});
  }

  requestSetCurrentSelectedMediaResult(currentSelectedMediaResult: FlatModels.SearchControlModels.MediaData) {
    return this.store.dispatch(new FlatActions.MediaAuthorActions.GetMediasByIds([currentSelectedMediaResult.id], true)).pipe(map(() => {
      this.store.dispatch(new FlatActions.SlideAuthorActions.CollapseMedia(false, true))
      return this.store.dispatch(new FlatActions.SearchControlActions.SetCurrentSelectedMediaResult(currentSelectedMediaResult));
    }))
  }

  requestResetCurrentSelectedMediaResult() {
    return this.store.dispatch(new FlatActions.SearchControlActions.SetCurrentSelectedMediaResult(null));
  }
  
  requestSetCurrentSelectedNodeResult(currentSelectedNodeResult: string) {
    return this.store.dispatch(new FlatActions.SearchControlActions.SetCurrentSelectedNodeResult(currentSelectedNodeResult));
  }

  //</editor-fold>
}
